import { IconsProps } from '@/types/shared'
import React from 'react'

const RejectedIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
            >
                <path
                    d="M10.6775 19.2L9.27754 17.8L11.5775 15.5L9.27754 13.2L10.6775 11.8L12.9775 14.1L15.2775 11.8L16.6775 13.2L14.3775 15.5L16.6775 17.8L15.2775 19.2L12.9775 16.9L10.6775 19.2ZM5.97754 22.5C5.42754 22.5 4.95671 22.3042 4.56504 21.9125C4.17337 21.5208 3.97754 21.05 3.97754 20.5V6.5C3.97754 5.95 4.17337 5.47917 4.56504 5.0875C4.95671 4.69583 5.42754 4.5 5.97754 4.5H6.97754V2.5H8.97754V4.5H16.9775V2.5H18.9775V4.5H19.9775C20.5275 4.5 20.9984 4.69583 21.39 5.0875C21.7817 5.47917 21.9775 5.95 21.9775 6.5V20.5C21.9775 21.05 21.7817 21.5208 21.39 21.9125C20.9984 22.3042 20.5275 22.5 19.9775 22.5H5.97754ZM5.97754 20.5H19.9775V10.5H5.97754V20.5ZM5.97754 8.5H19.9775V6.5H5.97754V8.5Z"
                    fill={props?.color || '#EE2424'}
                />
            </svg>
        </div>
    )
}

export default RejectedIcons
